import { render, staticRenderFns } from "./AppTabItem.vue?vue&type=template&id=409af269&"
import script from "./AppTabItem.vue?vue&type=script&lang=js&"
export * from "./AppTabItem.vue?vue&type=script&lang=js&"
import style0 from "./AppTabItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppTabItem.vue"
export default component.exports